/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PagesGestioneRilievoToolkitModule } from '@pages/gestione-rilievo/_toolkit/toolkit.module';
import { SharedModule } from '@shared/shared.module';
import { ToolkitGestioneOperaModalManutenzioneComponent } from './modal-manutenzione/modal-manutenzione.component';
import { ToolkitGestioneOperaModalMonitoraggioComponent } from './modal-monitoraggio/modal-monitoraggio.component';
import { ToolkitGestioneOperaModalOperaSecondariaComponent } from './modal-opera-secondaria/modal-opera-secondaria.component';
import { ToolkitGestioneOperaModalPianoInterventiComponent } from './modal-piano-interventi/modal-piano-interventi.component';
import { ToolkitGestioneOperaModalPianoRilieviComponent } from './modal-piano-rilievi/modal-piano-rilievi.component';
import { ToolkitGestioneOperaModalSopralluogoComponent } from './modal-sopralluogo/modal-sopralluogo.component';
import { ToolkitGestioneOperaModalUploadDocumentoComponent } from './modal-upload-documento/modal-upload-documento.component';
import { ToolkitGestioneOperaTabAnagraficaOperaComponent } from './tab-anagrafica-opera/tab-anagrafica-opera.component';
import { ToolkitGestioneOperaTabCartografiaComponent } from './tab-cartografia/tab-cartografia.component';
import { ToolkitGestioneOperaTabDatiCostruttiviOperaComponent } from './tab-dati-costruttivi-opera/tab-dati-costruttivi-opera.component';
import { ToolkitGestioneOperaTabDocumentiComponent } from './tab-documenti/tab-documenti.component';
import { ToolkitGestioneOperaTabManutenzioneComponent } from './tab-manutenzione/tab-manutenzione.component';
import { ToolkitGestioneOperaTabMonitoraggioComponent } from './tab-monitoraggio/tab-monitoraggio.component';
import { ToolkitGestioneOperaTabOpereSecondarieComponent } from './tab-opere-secondarie/tab-opere-secondarie.component';
import { ToolkitGestioneOperaTabPianoInterventiComponent } from './tab-piano-interventi/tab-piano-interventi.component';
import { ToolkitGestioneOperaTabPianoRilieviComponent } from './tab-piano-rilievi/tab-piano-rilievi.component';
import { ToolkitGestioneOperaTabSopralluoghiComponent } from './tab-sopralluoghi/tab-sopralluoghi.component';
import { ToolkitGestioneOperaTabMonitoraggiSopralluoghiComponent } from './tab-monitoraggi-sopralluoghi/tab-monitoraggi-sopralluoghi.component';
import { ToolkitGestioneOperaModalMonitoraggiSopralluoghiComponent } from './modal-monitoraggi-sopralluoghi/modal-monitoraggi-sopralluoghi.component';
import { ModalInfoComponent } from './modal-info/modal-info.component';
import { ModalMotivazioneComponent } from './modal-motivazione/modal-motivazione.component';
import { ModalRollbackOperaComponent } from './modal-rollback-opera/modal-info-rollback-opera.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgbModule,
        SharedModule,
        PagesGestioneRilievoToolkitModule
    ],
    declarations: [
        ToolkitGestioneOperaModalManutenzioneComponent,
        ToolkitGestioneOperaModalMonitoraggioComponent,
        ToolkitGestioneOperaModalOperaSecondariaComponent,
        ToolkitGestioneOperaModalPianoInterventiComponent,
        ToolkitGestioneOperaModalPianoRilieviComponent,
        ToolkitGestioneOperaModalSopralluogoComponent,
        ToolkitGestioneOperaModalMonitoraggiSopralluoghiComponent,
        ToolkitGestioneOperaModalUploadDocumentoComponent,
        ToolkitGestioneOperaTabAnagraficaOperaComponent,
        ToolkitGestioneOperaTabCartografiaComponent,
        ToolkitGestioneOperaTabDatiCostruttiviOperaComponent,
        ToolkitGestioneOperaTabDocumentiComponent,
        ToolkitGestioneOperaTabOpereSecondarieComponent,
        ToolkitGestioneOperaTabPianoInterventiComponent,
        ToolkitGestioneOperaTabPianoRilieviComponent,
        ToolkitGestioneOperaTabSopralluoghiComponent,
        ToolkitGestioneOperaTabMonitoraggioComponent,
        ToolkitGestioneOperaTabManutenzioneComponent,
        ToolkitGestioneOperaTabMonitoraggiSopralluoghiComponent,
        ModalInfoComponent,
        ModalMotivazioneComponent,
        ModalRollbackOperaComponent
    ],
    exports: [
        ToolkitGestioneOperaModalManutenzioneComponent,
        ToolkitGestioneOperaModalMonitoraggioComponent,
        ToolkitGestioneOperaModalOperaSecondariaComponent,
        ToolkitGestioneOperaModalPianoInterventiComponent,
        ToolkitGestioneOperaModalPianoRilieviComponent,
        ToolkitGestioneOperaModalSopralluogoComponent,
        ToolkitGestioneOperaModalUploadDocumentoComponent,
        ToolkitGestioneOperaTabAnagraficaOperaComponent,
        ToolkitGestioneOperaTabCartografiaComponent,
        ToolkitGestioneOperaTabDatiCostruttiviOperaComponent,
        ToolkitGestioneOperaTabDocumentiComponent,
        ToolkitGestioneOperaTabOpereSecondarieComponent,
        ToolkitGestioneOperaTabPianoInterventiComponent,
        ToolkitGestioneOperaTabPianoRilieviComponent,
        ToolkitGestioneOperaTabSopralluoghiComponent,
        ToolkitGestioneOperaTabMonitoraggioComponent,
        ToolkitGestioneOperaTabManutenzioneComponent,
        ToolkitGestioneOperaTabMonitoraggiSopralluoghiComponent
    ],
    entryComponents: [
        ToolkitGestioneOperaModalManutenzioneComponent,
        ToolkitGestioneOperaModalMonitoraggioComponent,
        ToolkitGestioneOperaModalOperaSecondariaComponent,
        ToolkitGestioneOperaModalPianoInterventiComponent,
        ToolkitGestioneOperaModalPianoRilieviComponent,
        ToolkitGestioneOperaModalSopralluogoComponent,
        ToolkitGestioneOperaModalUploadDocumentoComponent,
        ToolkitGestioneOperaModalMonitoraggiSopralluoghiComponent
    ],
})
export class PagesGestioneOperaToolkitModule { }
